//utility methods used to map statuses and determine styling for statuses
//used by service request pages
const statusDisplayMap: Record<string, string> = {
  'new': 'New / Waiting',
  'in progress': 'In Progress',
  'pending': 'Further Action Required',
  'completed': 'Completed',
  'closed': 'Closed'
};

const statusClassMap: Record<string, string> = {
  'new': 'status-response-received',
  'in progress': 'status-response-received',
  'pending': 'status-action-required',
  'completed': 'status-completed',
  'closed': 'status-completed'
};

export function getStatusDisplay(status: string): string {
  return statusDisplayMap[status.toLowerCase()] ?? status;
}

export function getStatusClass(status: string): string {
  return statusClassMap[status.toLowerCase()] ?? 'chip-outline-secondary';
}
